/* eslint-disable indent */
import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const CloseButton = styled(CloseOutlined)`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: rgba(0, 0, 0, 0.75);
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const ColoredBackground = styled.div<{ $percent: number }>`
  background-color: ${({ theme, $percent }) =>
    $percent >= 75
      ? theme.colors.green8
      : $percent >= 50
      ? theme.colors.orange8
      : theme.colors.red8};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding-top: 32px;
  padding-bottom: 250px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    padding-bottom: 210px;
  }
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const SuccesesText = styled.span`
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 24px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
  border-top: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
`;

export const QuizMode = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 500;
`;
